import { render, staticRenderFns } from "./MediaSetting.vue?vue&type=template&id=810e0f48&"
import script from "./MediaSetting.vue?vue&type=script&lang=js&"
export * from "./MediaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports